import * as angular from 'angular';
import {IController} from "angular";

export class BringozPhoneCopyCtrl implements IController {
  phone: string;

  public canCopy: boolean;
  public textToCopy: string;

  /* @ngInject */
  constructor(private $filter) {

  }

  $onInit() {

  }

  onEnter() {
    const phoneNumberToCopy = this.$filter('bringozPhone')(this.phone);
    this.textToCopy = phoneNumberToCopy.replace(/\D/g,'');
  }

  onLeave() {
    this.textToCopy = undefined;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozPhoneCopy', {
    bindings: {
      phone: '<'
    },
    template: require('./bringoz-phone-copy.html').default,
    controller: BringozPhoneCopyCtrl
  });
